<script>
	export let type = "bar"; // or triangle
	export let colorScale;
	export let currentColor;
	export let maxValue;
	export let currentValue;
	export let highlightedValues = [];
	export let formatValue = (v) => v;

	// const maxValue = colorScale.domain()[colorScale.domain().length - 1];

	const gradient =
		"linear-gradient(to right, " +
		colorScale
			.range()
			.map((color, index) => {
				const domainValue = colorScale.domain()[index];
				const percent = (domainValue / maxValue) * 100; // Assuming 0.045 is your max value in domain
				return `${color} ${percent}%`;
			})
			.join(", ") +
		")";

	$: currentPercent = (currentValue / maxValue) * 100;
</script>

<div class="single-bar-chart type-{type}">
	<div class="bar-wrapper">
		<div class="bar" style:background={gradient} />
		{#if type === "triangle"}
			<div class="bar-triangle top" />
			<div class="bar-triangle bottom" />
		{/if}
	</div>
	<div class="bar-values">
		{#each highlightedValues as highlight}
			{@const position = (highlight.value / maxValue) * 100}
			<div
				class="value-wrapper {highlight.id}"
				class:left-aligned={highlight.aligned === "left"}
				class:right-aligned={highlight.aligned === "right"}
				style:left="{position}%"
			>
				<div class="line" />
				<div class="value">
					{formatValue(highlight.value)}
				</div>
				<div class="description">⌀ Berlin</div>
			</div>
		{/each}
	</div>
	<div class="pointer" style:left="{Math.min(currentPercent, 100)}%">
		<div class="triangle-wrapper">
			<div class="triangle border" />
			<div class="triangle fill" style:border-top-color={currentColor} />
		</div>
		<div class="line-background" />
		<div class="line" />
	</div>
</div>

<style lang="scss">
	.type-triangle {
		.bar-wrapper {
			height: 30px;
		}

		.pointer {
			.line {
				height: 44px;
			}
		}
	}

	.bar-triangle {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 50%;
		background: #fff;
		clip-path: polygon(0% 0%, 0% 100%, 100% 0%);

		&.bottom {
			clip-path: polygon(0% 0%, 0% 100%, 100% 100%);
			top: 51%;
		}
	}

	.pointer {
		position: absolute;
		top: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		transform: translate(-50%, -17px);
		transition: left 0.3s ease-in-out;
		z-index: 2;

		.line {
			width: 1px;
			height: 28px;
			background: $black;

			&:before {
				content: "";
				display: block;
				width: 3px;
				background: #fff;
				height: 100%;
				position: relative;
				z-index: -1;
				transform: translateX(-1px);
			}
		}

		.triangle-wrapper {
			display: flex;

			.triangle {
				width: 0px;
				height: 0px;
				border-style: solid;
				border-width: 9px 8px 0 8px;
				border-color: transparent;
				transform: rotate(0deg);

				&.border {
					border-color: $black transparent transparent transparent;
					transform: scale(1.4);
					transform-origin: top center;
				}

				&.fill {
					position: absolute;
					transform: translateY(1.5px);
					transition: border-top-color 0.3s ease-in-out;
				}
			}
		}
	}

	$width: 100%;

	.bar-wrapper {
		position: relative;
		width: $width;
		margin-top: 3px;
		height: 12px;

		.bar {
			height: 100%;
		}

		.gradient {
			position: absolute;
			right: 0;
			top: 0;
			width: 10%;
			height: 100%;
			background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, #ffffff 80%);
		}
	}

	.bar-values {
		position: relative;
		height: 35px;
		width: $width;

		.value-wrapper {
			position: absolute;
			font-size: 12px;
			font-weight: $medium;
			line-height: 110%;
			color: #767676;
			transform: translateX(-50%);
			display: flex;
			flex-direction: column;
			align-items: center;

			.line {
				height: 8px;
				width: 1px;
				background-color: #767676;
				margin-bottom: 2px;
			}

			&.right-aligned {
				align-items: flex-end;
				transform: translateX(-100%);
			}

			&.left-aligned {
				align-items: flex-start;
				transform: translateX(0%);
			}

			.description {
				white-space: nowrap;
			}
		}
	}
</style>
